export const GET_SOURCE_DATA_START = "GET_SOURCE_DATA_START"
export const GET_SOURCE_DATA_SUCCESS = "GET_SOURCE_DATA_SUCCESS"
export const GET_SOURCE_DATA_ERROR = "GET_SOURCE_DATA_ERROR"